import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TerminalStatusFilter, TerminalStatusPage } from '../models/terminal-status.model';

@Injectable({ providedIn: 'root' })
export class TerminalStatusService {
  private readonly baseUrl = environment.subscriptionApiUrl + '/api/admin/terminals';

  constructor(private http: HttpClient) {}

  /**
   * Terminals across every business, worst-reporting first. Server-side paged and filtered — the
   * platform has far more terminals than a client-side filter could sensibly hold.
   */
  getTerminals(
    page = 1,
    pageSize = 25,
    status: TerminalStatusFilter = '',
    searchTerm = '',
    businessId = ''
  ): Observable<TerminalStatusPage> {
    let params = new HttpParams()
      .set('page', page)
      .set('pageSize', pageSize);

    if (status) params = params.set('status', status);
    if (searchTerm) params = params.set('searchTerm', searchTerm);
    if (businessId) params = params.set('businessId', businessId);

    return this.http.get<TerminalStatusPage>(this.baseUrl, { params });
  }
}
